// AboutUs.jsx
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const AboutUs = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-900">
      {/* Header */}
      <header className="bg-gray-800 text-white px-2 py-6 w-full">
        <h2 className="text-xl lg:text-2xl text-cyan-200 font-bold text-center break-words">
          Think5Whys About Us
        </h2>
      </header>

      {/* Main Content */}
      <main className="flex-grow w-full py-6 overflow-x-auto">
        <div className="bg-gray-800 text-white p-4 sm:p-6 md:p-8 rounded-lg shadow-lg w-full">
          <p className="text-sm lg:text-lg text-white mb-4 leading-relaxed break-words">
            <strong className="text-yellow-400">1. About the Platform:</strong> 
            The Learning module is your gateway to a wealth of knowledge. Access various resources, whitepapers, videos, and courses designed to enhance critical thinking skills using the Think5Whys framework. Elevate your understanding and application of this powerful methodology.
          </p>

          <p className="text-sm lg:text-lg text-white mb-4 leading-relaxed break-words">
            <strong className="text-yellow-400">2. About the founder:</strong>
            Sanjeev Kumar is the founder of Think5Whys concept.
          </p>

          <div className="mb-4">
            <p className="text-sm lg:text-base text-white mb-4 leading-relaxed break-words">
              Sanjeev Kumar is an experienced professional, writer passionate about research, product development, teaching, mentoring, technology solutions, and continuous process improvement. With over 28 years of diverse experience in education, corporate roles, and entrepreneurship, Sanjeev brings extensive knowledge and expertise to his work. His notable contribution in the e-commerce industry has been as a solution architect, technical architect, business transformer, and other key operational as well as analytical roles, including digital strategy and heading the e-commerce department.
            </p>

            <p className="text-sm lg:text-base text-white mb-4 leading-relaxed break-words">
              Having a Six Sigma Black Belt certification, Sanjeev showcases mastery in process improvement methodologies. He holds an MCA degree, a B.Sc. in Mathematics (Honors), and pursued an MBA in Finance. This diverse educational background enables him to bridge theory and practice effectively.
            </p>

            <p className="text-sm lg:text-base text-white mb-4 leading-relaxed break-words">
              Sanjeev's career focuses on empowering through education and mentoring, guiding individuals effectively with his simplified teaching style. In addition to teaching, Sanjeev has actively participated in entrepreneurship and project management in corporate settings, providing practical insights in his writing.
            </p>

            <p className="text-sm lg:text-base text-white mb-4 leading-relaxed break-words">
              As an author, Sanjeev is committed to creating impactful and accessible content. His books inspire young minds, stimulate critical thinking, and nurture a passion for lifelong learning. His expertise in Six Sigma and talent for conveying complex concepts make his works valuable resources for leaders, workers, researchers, students, educators, and professionals.
            </p>

            <p className="text-sm lg:text-base text-white mb-4 leading-relaxed break-words">
              His couple of upcoming creations, <em>“Processifyd”</em> is to provide a solution framework to power youth and women lead startups across the globe, and <em>"Purple Power,"</em> introduces Six Sigma to K12, aiming to certify kids worldwide with the Six Sigma Purple Belt.
            </p>

            <p className="text-sm lg:text-base text-white mb-4 leading-relaxed break-words">
              Sanjeev's exceptional record and genuine drive continue to impact education and continuous improvement.
            </p>

            <p className="text-sm lg:text-base text-white mb-4 leading-relaxed break-words">
              <strong className="text-yellow-400">Sanjeev's Social Profile: </strong>
              <a href="https://www.linkedin.com/in/sanjeevkumarmumbai" className="text-blue-400 hover:underline break-all" target="_blank" rel="noopener noreferrer">https://www.linkedin.com/in/sanjeevkumarmumbai</a>
            </p>

            <p className="text-sm lg:text-base mb-4 leading-relaxed break-words">
              <strong className="text-yellow-400">Emails to reach out: </strong>
              <a href="mailto:contact@processifyd.com" className="text-blue-400 hover:underline">contact@processifyd.com</a>, 
              <a href="mailto:think5whys@gmail.com" className="text-blue-400 hover:underline">think5whys@gmail.com</a>, 
              <a href="mailto:sanjeev@processifyd.com" className="text-blue-400 hover:underline">sanjeev@processifyd.com</a>, 
              <a href="mailto:sanjeevkumarmumbai@gmail.com" className="text-blue-400 hover:underline">sanjeevkumarmumbai@gmail.com</a>
            </p>
          </div>

          <p className="text-sm lg:text-base text-white mb-4 leading-relaxed break-words">
            <strong className="text-yellow-400">3. About the team:</strong><br />
            <strong>Babita Sinha (Co-founder)</strong>
          </p>

          <p className="text-sm lg:text-base text-white mb-4 leading-relaxed break-words">
            <strong className="text-yellow-400">4. Contact:</strong><br />
            <strong className="block text-sm lg:text-base break-all">Registered Address: B-1402, Riviera, Casa-Bella, Palava, Kalyan-Shil Road, Dombivali (East), Thane, Mumbai Metropolitan Region, Maharashtra, India, Postal Code: 421204</strong>
          </p>

          <p className="text-sm lg:text-base text-white mb-4 leading-relaxed break-words">
            <strong className="text-yellow-400">5. Email:</strong> 
            <a href="mailto:contact@think5whys.com" className="text-blue-400 hover:underline">contact@think5whys.com</a>
          </p>

          <p className="text-sm lg:text-base text-white mb-4 leading-relaxed break-words">
            <strong className="text-yellow-400">6. WhatsApp:</strong> 
            <a href="tel:+919324342890" className="text-blue-400 hover:underline">+91 9324342890</a>
          </p>
        </div>
      </main>

      <footer className="bg-black border-t border-blue-800 text-white py-4 w-full mt-auto">
        <div className="w-full px-2 sm:px-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-3">
            <div className="text-xs sm:text-sm lg:text-lg text-yellow-200 text-center md:text-left break-words">
              © {new Date().getFullYear()} Think5Whys Global DeepTech Solutions.
            </div>
            <nav className="flex flex-wrap justify-center md:justify-end gap-2 sm:gap-4 text-xs sm:text-sm">
              <Link to="/about-us" className="text-white hover:text-yellow-200">About</Link>
              <Link to="/privacy-policy" className="text-white hover:text-yellow-200">Privacy Policy</Link>
              <Link to="/terms-of-use" className="text-white hover:text-yellow-200">Terms of Use</Link>
              <Link to="/contact-us" className="text-white hover:text-yellow-200">Contact</Link>
            </nav>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AboutUs;